import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ResultsGridSection from './ResultsGridSection';
import { useRecommendedAppsQuery } from '../../hooks/useRecommendedAppsQuery';
import { jsx as _jsx } from "react/jsx-runtime";
export default function RecommendedResultsSection({
  onResultClick
}) {
  const {
    data: results,
    requestState
  } = useRecommendedAppsQuery();
  return /*#__PURE__*/_jsx(Fragment, {
    children: results.length ? /*#__PURE__*/_jsx(ResultsGridSection, {
      onResultClick: onResultClick,
      requestState: requestState,
      results: results,
      section: "mpdi0001::section",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "appMarketplace.storefront.recommended.headingText"
      })
    }) : null
  });
}